lmApp
.service('ApplicationService', ['$q', 'ApiService', function ($q, ApiService) {
    var service = {};

    service.CreateCNAME = function (alias) {
      var data = {
        alias: alias
      };

      return ApiService.Request('1/services/app.stockweb/alias/create', 'POST', data);
    };

    service.RemoveCNAME = function (alias) {
      var data = {
        alias: alias
      };

      return ApiService.Request('1/services/app.stockweb/alias/remove', 'POST', data);
    };

    service.UpdatePlatform = function (data) {
      var deferred = $q.defer();

      var platformData = {
        platform_id: data.id
      };

      if (data.app_url) platformData.app_url = data.app_url;
      if (data.logo_url) platformData.logo_url = data.logo_url;

      lh.common.request.post('cloud/mgmt/operator/platform/update', platformData)
        .then(function (response) {
          deferred.resolve();
        }, function (reason) {
          reason.url = 'cloud/mgmt/operator/platform/update';
          reason.data = platformData;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    return service;
  }]);
